import React, { useEffect, useState } from 'react';
import { auth } from '../../firebase-config'; // Ensure this path is correct
import { Container, Typography, CircularProgress } from '@mui/material';

const Logout = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const performLogout = () => {
      auth.signOut()
        .then(() => {
          window.location.replace("/");
        })
        .catch((err) => {
          setError('Failed to log out. Please try again.');
          console.error('Logout error:', err);
        });
    };

    performLogout();
  }, [auth]);

  return (
    <Container maxWidth="sm" style={{ marginTop: '20px', textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>
        Logging out...
      </Typography>
      {!error ? (
        <CircularProgress style={{ marginTop: '20px' }} />
      ) : (
        <Typography variant="body1" color="error" style={{ marginTop: '20px' }}>
          {error}
        </Typography>
      )}
    </Container>
  );
};

export default Logout;
